// extracted by mini-css-extract-plugin
export default {"container":"OriAvatar_container__24MCf","avatar":"OriAvatar_avatar__4TQd2"};